// Paleta moderna pros gráficos do dashboard.
// Tons mais alegres e harmônicos vs verde/vermelho saturados do default.

export const CHART_COLORS = {
  // Pares principais (com gradient stops claro/escuro)
  income: {
    base: '#10b981',
    light: '#34d399',
    glow: '#6ee7b7',
  },
  expense: {
    base: '#f43f5e',
    light: '#fb7185',
    glow: '#fda4af',
  },
  invested: {
    base: '#6366f1',
    light: '#818cf8',
    glow: '#a5b4fc',
  },
  passive: {
    base: '#06b6d4',
    light: '#22d3ee',
    glow: '#67e8f9',
  },
};

// Paleta categórica pro donut (5+ categorias) — tons alegres harmônicos
export const CATEGORY_PALETTE = [
  '#6366f1', // indigo
  '#10b981', // emerald
  '#f59e0b', // amber
  '#ec4899', // pink
  '#06b6d4', // cyan
  '#8b5cf6', // violet
  '#f43f5e', // rose
  '#84cc16', // lime
];

export const CHART_GRADIENTS = {
  income: {
    id: 'gradient-income',
    from: '#34d399',
    to: '#10b98180', // 50% opacity
  },
  expense: {
    id: 'gradient-expense',
    from: '#fb7185',
    to: '#f43f5e80',
  },
  invested: {
    id: 'gradient-invested',
    from: '#818cf8',
    to: '#6366f180',
  },
  expenseLine: {
    id: 'gradient-expense-line',
    from: '#fb7185',
    to: '#f43f5e80',
  },
  area: {
    income: { id: 'area-income', from: '#34d39966', to: '#34d39900' },
    invested: { id: 'area-invested', from: '#818cf866', to: '#818cf800' },
    expense: { id: 'area-expense', from: '#fb718566', to: '#fb718500' },
  },
};

// Easing "saltitante" — overshoot leve, sensação alegre
export const EASING = {
  bounceOut: [0.34, 1.56, 0.64, 1],
  smoothOut: [0.22, 1, 0.36, 1],
  natural: [0.4, 0, 0.2, 1],
};

export const STAGGER_DELAY = 0.08; // 80ms entre cards/elementos
